import { ProductLine } from "../types";
import { adaptComputedCost } from "./adaptComputedCost";
import { computeProductsCost } from "./computeProductsCost";

type Params = {
  productLines: ProductLine[];
  productsMarginRatio: number | null;
  quantityInAssembly: number | null;
};

export const computeProductsPrice = ({
  productLines,
  productsMarginRatio,
  quantityInAssembly,
}: Params): {
  productsPrice: number;
  productsCost: number;
  productsMargin: number;
} => {
  const computedProductsCost = computeProductsCost({
    productLines,
    quoteRequestLineQuantity: 1,
    quantityInAssembly,
  });

  const computedProductsMargin = computedProductsCost * ((productsMarginRatio ?? 0) / 100);

  const { price: productsPrice } = adaptComputedCost({
    cost: computedProductsCost,
    marginPrice: computedProductsMargin,
  });

  return {
    productsPrice,
    productsCost: computedProductsCost,
    productsMargin: computedProductsMargin,
  };
};
